// Default search values
export const searchValues = {
  user: "",
  date: "",
  toDate: new Date(new Date().setHours(23, 59, 59, 999)),
  keyword: "",
  fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
};

// Mapping of Excel header cells to their corresponding data fields
export const excelHeaderCellsName = {
  "المعرف": "id",
  "نشط": "isActive",
  "العنوان": "title",
  "مؤرشف": "isArchive",
  "قيمة البحث": "queryValue",
  "إنشاء نسخ": "createCopies",
  "تاريخ الإنشاء": "createdOn",
  "عدد النسخ": "numberOfCopies",
  "معرف الافلييت": "affiliateId",
  "اسم الافلييت": "affiliateName",
  "عدد الزيارات": "numberOfVisits",
  "هاتف الافلييت": "affiliatePhone",
  "عدد التبرعات": "numberOfDonations",
  "رابط الافلييت الكامل": "affiliateFullLink",
  "بريد الافلييت الإلكتروني": "affiliateEmail",
  "إجمالي مبلغ التبرعات": "totalDonationAmount",
};

// affiliate link aggregation
export const linksAggregationDefault = {
  totalNumberOfVisits: 0,
  totalNumberOfDonations: 0,
  totalDonationAmount: 0,
};
